module.exports = __webpack_public_path__ + "static/media/people8.81533c8c.jpeg";